var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileDocsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.9998V10.5695C16 9.59214 16.7923 8.7998 17.7697 8.7998H37C37.6627 8.7998 38.2 9.33706 38.2 9.99981L38.2 14.7998C38.2 15.4625 38.7373 15.9998 39.4 15.9998H43.6C44.2627 15.9998 44.8 16.5371 44.8 17.1998V41.7887C44.8 42.7661 44.0077 43.5584 43.0303 43.5584H40.6",
    stroke: "#1A1B1D",
    strokeWidth: 1.44
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8 24.9998L44.8 16.7823C44.8 16.4913 44.6943 16.2102 44.5025 15.9913L38.5585 9.2089C38.3307 8.9489 38.0018 8.7998 37.656 8.7998H17.7697C16.7923 8.7998 16 9.59214 16 10.5695V12.9998",
    stroke: "#1A1B1D",
    strokeWidth: 1.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1199 14.1696C13.1199 13.5899 13.5899 13.1199 14.1696 13.1199H32.9248C33.2029 13.1199 33.4697 13.2303 33.6665 13.4268L40.1719 19.9219C40.3691 20.1189 40.4799 20.3861 40.4799 20.6648V45.3888C40.4799 45.9685 40.0099 46.4385 39.4302 46.4385H14.1696C13.5899 46.4385 13.1199 45.9685 13.1199 45.3888V14.1696Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.44
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1199 14.1696C13.1199 13.5899 13.5899 13.1199 14.1696 13.1199H31.8873C32.4671 13.1199 32.937 13.5899 32.937 14.1696V19.0461C32.937 19.9324 33.6556 20.6509 34.5419 20.6509H39.4302C40.0099 20.6509 40.4799 21.1209 40.4799 21.7007V45.3888C40.4799 45.9685 40.0099 46.4385 39.4302 46.4385H14.1696C13.5899 46.4385 13.1199 45.9685 13.1199 45.3888V14.1696Z",
    stroke: "#1A1B1D",
    strokeWidth: 1.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 36.5L18 36.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36.5L24.875 36.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 37.875L23.5 42",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 31L23.5 35.125",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8.5L45 8.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8.5L50 8.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49 9.5L49 12.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49 4.5L49 7.5",
    stroke: "#1A1B1D",
    strokeWidth: 1.35,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileDocsIcon);
export default __webpack_public_path__ + "static/media/mobile-docs-icon.e06e3f02c239165c3a08866591c34e0e.svg";
export { ForwardRef as ReactComponent };